import { IssueSort } from '../config';

// Даты свежие сверху, остальное — по возрастанию
export const firstDirection = (field: IssueSort['field']) =>
  ['updateTime', 'createTime', 'priority'].includes(field) ? 'desc' : 'asc';
